import { Trans } from "@lingui/macro";
import { testAppendAttr } from "@smp/utils";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";

import { useDialog } from "@/hooks/use_dialog";
import { useEpPageconfigListRecursive } from "@/hooks/use_ep_pageconfig";
import { useHumanizer } from "@/hooks/use_humanizer";
import { useContextApp } from "@/screens/app/context/app";

import { HeaderButton } from "../../shared";
import { DialogPolotno } from "./dialog_polotno";

export const Polotno = () => {
  const { humanizeBillingGroupId } = useHumanizer();
  const {
    state: { plansubscriptionActive, plansubscriptionLast, planLast },
  } = useContextApp();

  const {
    close: dialogClose,
    isOpen: isDialogOpen,
    open: dialogOpen,
  } = useDialog();

  const { isPageconfigListLoading, pageconfigList } =
    useEpPageconfigListRecursive({
      req: {
        query: { all_organization_contexts: "True", has_scheduled_posts: true },
      },
    });

  if (isPageconfigListLoading) {
    return null;
  }

  if (!pageconfigList) {
    return null;
  }

  const isExpired = !!plansubscriptionLast && !plansubscriptionActive;

  return (
    <>
      <HeaderButton
        captionLeft={
          !!plansubscriptionLast && !!plansubscriptionActive ? (
            <>
              <Trans>until</Trans>{" "}
              {format(parseISO(plansubscriptionLast.period_end), "dd.MM.yyyy")}
            </>
          ) : undefined
        }
        onClick={dialogOpen}
        isExpired={isExpired}
        textLeft={
          <span style={{ display: "block", fontSize: 16, lineHeight: "16px" }}>
            {planLast?.group.id
              ? humanizeBillingGroupId(planLast?.group.id)
              : ""}
          </span>
        }
        {...testAppendAttr("id", `header_billing_polotno`)}
      />
      {isDialogOpen && <DialogPolotno onClose={dialogClose} />}
    </>
  );
};
